import cx from 'classnames2';

import React, { createContext, useContext } from 'react';

import { matchDisplayName } from '../utils';

import styles from './ListTable.module.scss';

export interface IListTableProps {
  dataTest?: string;
  hasIcon?: boolean;
  isSelectable?: boolean;
  name?: string;
  variant?: 'default' | 'condensed' | 'minimal';
}

export const ListTableContext = createContext({
  hasIcon: false,
  isSelectable: false,
  variant: 'default'
});

export const useListTableContext = () => useContext(ListTableContext);

export const ListTable: React.FC<IListTableProps> = ({ dataTest, hasIcon, isSelectable, variant, children }) => {
  let hasCards = false;
  React.Children.map(children, (childRef) => {
    if (matchDisplayName(childRef, 'ListTableCard')) {
      hasCards = true;
    }
  });
  return (
    <ListTableContext.Provider
      value={{
        variant: variant,
        hasIcon: hasIcon,
        isSelectable: isSelectable
      }}
    >
      <div
        className={cx({
          [styles.cardContainer]: hasCards,
          [styles.container]: !hasCards,
          [styles.variantMinimal]: variant === 'minimal'
        })}
        data-test={dataTest}
      >
        {children}
      </div>
    </ListTableContext.Provider>
  );
};
